<template>
    <app-layout>
        <section
            class="shadow-sm bg-white rounded-lg pt-4 pb-2 px-6 w-full md:w-1/2"
        >
            <text-input
                v-model="form.coupon_name"
                label="Coupon name"
                class="mb-5"
            />

            <textarea-input
                v-model="form.note"
                label="Note"
                class="mb-5"
            />

            <number-input
                v-model="form.discount_amount"
                label="Discount amount"
                class="mb-5"
            />

            <select-input
                v-model="selectedDiscountType"
                label="Discount type"
                :options="discountTypeOptions"
                class="mb-5"
            />

            <date-input
                v-model="form.valid_from"
                label="Valid from"
                class="mb-5"
            />

            <date-input
                v-model="form.valid_till"
                label="Valid till"
                class="mb-5"
            />

            <select-input
                v-model="selectedCountry"
                label="Country"
                :options="countryOptions"
                @input="searchCountry"
                class="mb-5"
                :error="errors['country_id'] ? errors['country_id'][0] : ''"
            />

            <button-input
                text="Create"
                :loading="loading"
                :disabled="loading"
                @click="submit"
            />
        </section>
        <!-- <create-view
            :model="model"
        /> -->
    </app-layout>
</template>

<script>
import AppLayout from "../../layouts/AppLayout.vue";
import CreateView from "../../components/views/create/Index.vue";
import {mapGetters} from "vuex";

export default {
    name: "CouponsCreate",

    components: {
        CreateView,
        AppLayout
    },

    data() {
        return {
            loading: false,
            form: {
                coupon_name: '',
                note: '',
                discount_amount: '',
                discount_type: '',
                valid_from: '',
                valid_till: '',
                rental_days: '',
                country_id: '',
                is_special_coupon: '',
                day_15_to_30_price: '',
                day_31_plus_price: '',
            },
            discountTypeOptions: [
                {name: 'Amount', value: 'amount'},
                {name: 'Percent', value: 'percent'},
            ],
            selectedDiscountType: {},
            countryOptions: [],
            selectedCountry: {},
            errors: {}
        }
    },

    computed: {
        ...mapGetters({
            model: 'coupons/getModel',
        })
    },

    created() {
        this.init();
    },

    methods: {
        init() {
            this.loading = true;
            this.searchCountry('');
            this.loading = false;
        },

        searchCountry: _.debounce(function (value) {
            this.$store.dispatch("countries/search", {
                keywords: value,
                limit: 10
            }).then(res => {
                this.countryOptions = res.data;
            }).catch(error => {
                this.$toast.warning(error.data.message);
            });
        }, 300),

        submit() {
            this.loading = true;

            let formData = this.form;
            formData.country_id = this.selectedCountry.id;
            formData.discount_type = this.selectedDiscountType.value;

            this.$store.dispatch("coupons/create", formData)
                .then(() => {
                    this.$router.push(`/coupons`);
                    this.loading = false;
                })
                .catch(error => {
                    this.$toast.warning(error.data.message);
                    this.errors = error.data.errors;
                    this.loading = false;
                });
        }
    }
}
</script>

<style lang="sass">

</style>